var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpPcGuideIconBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.5,
    cy: 4.5,
    r: 4.25,
    stroke: "#05073C",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9375 4.5C5.9375 5.7206 5.75155 6.81451 5.45916 7.5942C5.31262 7.98497 5.14416 8.28383 4.96979 8.48052C4.79515 8.67749 4.63583 8.75 4.5 8.75C4.36417 8.75 4.20485 8.67749 4.03021 8.48052C3.85584 8.28383 3.68738 7.98497 3.54084 7.5942C3.24845 6.81451 3.0625 5.7206 3.0625 4.5C3.0625 3.2794 3.24845 2.18549 3.54084 1.4058C3.68738 1.01503 3.85584 0.716166 4.03021 0.519484C4.20485 0.322511 4.36417 0.25 4.5 0.25C4.63583 0.25 4.79515 0.322511 4.96979 0.519484C5.14416 0.716166 5.31262 1.01503 5.45916 1.4058C5.75155 2.18549 5.9375 3.2794 5.9375 4.5Z",
    stroke: "#05073C",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.28125 4.5H8.71875",
    stroke: "#05073C",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpPcGuideIconBlack);
export default __webpack_public_path__ + "static/media/cp-pc-guide-icon-black.2090b864237be187c30fdcff1a710cfc.svg";
export { ForwardRef as ReactComponent };